import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import classNames from 'classnames';

var BVProductPicker = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(BVProductPicker, _React$Component);

  function BVProductPicker(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var hashTrigger = _this.props.hashTrigger;
      var shouldLoad = false;

      if (hashTrigger) {
        shouldLoad = window.location.hash.toLowerCase().indexOf(hashTrigger.toLowerCase()) !== -1;
      } else {
        shouldLoad = true;
      }

      _this.setState({
        isLoaded: shouldLoad
      });
    });

    _this.state = {
      isLoaded: false
    };
    return _this;
  }

  var _proto = BVProductPicker.prototype;

  _proto.render = function render() {
    var _classNames;

    var className = classNames('bv-product-picker', (_classNames = {}, _classNames["" + this.props.className] = this.props.className, _classNames));
    return this.state.isLoaded && /*#__PURE__*/React.createElement("div", {
      className: className,
      "data-bv-show": "product_picker",
      "data-bv-inline": this.props.inline,
      "data-bv-category-id": this.props.categoryID,
      "data-bv-family-product-id": this.props.productFamilyID,
      "data-bv-hash-trigger": this.props.hashTrigger
    });
  };

  return BVProductPicker;
}(React.Component);

export { BVProductPicker as default };
BVProductPicker.defaultProps = {
  inline: false
};